import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { COLORS } from '../theme';

/** Fallback de Suspense para rotas carregadas sob demanda. */
const PageLoader = ({ minHeight = '60vh' }) => (
  <Box
    role="status"
    aria-live="polite"
    aria-label="Carregando página"
    sx={{
      minHeight,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'transparent',
    }}
  >
    <CircularProgress sx={{ color: COLORS.orange }} />
  </Box>
);

export default PageLoader;
